import { ImageMetadata } from '../types/image-preview';

export const extractImageMetadata = (file: File): Promise<ImageMetadata> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    
    img.onload = () => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      const aspectRatio = width / height;
      
      resolve({
        width,
        height,
        size: file.size,
        type: file.type,
        name: file.name,
        lastModified: file.lastModified,
        aspectRatio: Number(aspectRatio.toFixed(2))
      });
      
      URL.revokeObjectURL(img.src);
    };
    
    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      reject(new Error('无法加载图片'));
    };
    
    img.src = URL.createObjectURL(file);
  });
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDimensions = (width: number, height: number): string => {
  return `${width} × ${height}`;
};

export const formatAspectRatio = (ratio: number): string => {
  // 常见比例识别
  const commonRatios: Record<string, number> = {
    '1:1': 1,
    '4:3': 4/3,
    '3:2': 3/2,
    '16:9': 16/9,
    '16:10': 16/10
  };

  for (const [name, value] of Object.entries(commonRatios)) {
    if (Math.abs(ratio - value) < 0.01) {
      return name;
    }
  }

  return `${ratio.toFixed(2)}:1`;
};